import {
  CLEAR_KEYTERM,
  CLEAR_PROGRESS,
  HIDE_LINKBAR,
  HIDE_SIDEBAR,
  SET_KEYTERM,
  SET_SECTION,
  TOGGLE_LINKS_SIDEBAR,
  TOGGLE_SHARE_MODAL,
  TOGGLE_SIDEBAR,
  UPDATE_ACTIVITIES,
  UPDATE_CURRENT_TOPIC,
  UPDATE_FINISHED_TOPICS,
  UPDATE_KEY_TERMS,
  UPDATE_LANGUAGE,
  UPDATE_MODULES,
  UPDATE_PAGES,
  UPDATE_PARTS,
  UPDATE_PROGRESS,
  UPDATE_TOPICS,
  UPDATE_USER,
  UPDATE_CURRENT_LANGUAGE,
  UPDATE_SHARES_COUNT,
  UPDATE_SHARES_ID,
  TOGGLE_BADGE_MODAL,
  TOGGLE_SHARE_BADGE_MODAL,
  TOGGLE_UPDATE_SIDEBAR,
  UPDATE_AFFILIATE,
  UPDATE_ADOBE_SETTINGS,
  UPDATE_CONFIG,
  TOGGLE_SWEEPSTAKES_BADGE_MODAL,
  SHOW_SWEEPSTAKES_BADGE_MODAL,
  UPDATE_FINISHED_SUB_SECTION
} from "./actionTypes";

export const updateModulesAction = (payload) => ({
  type: UPDATE_MODULES,
  payload,
});

export const updateTopicsAction = (payload) => ({
  type: UPDATE_TOPICS,
  payload,
});

export const updatePartsAction = (payload) => ({
  type: UPDATE_PARTS,
  payload,
});

export const updateKeyTermsAction = (payload) => ({
  type: UPDATE_KEY_TERMS,
  payload,
});

export const updateActivitiesAction = (payload) => ({
  type: UPDATE_ACTIVITIES,
  payload,
});

export const updatePagesAction = (payload) => ({
  type: UPDATE_PAGES,
  payload,
});

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});
export const toggleUpdateSidebar = () => ({
  type: TOGGLE_UPDATE_SIDEBAR,
});
export const hideSidebar = () => ({
  type: HIDE_SIDEBAR,
});

export const toggleLinksSidebar = () => ({
  type: TOGGLE_LINKS_SIDEBAR,
});
export const toggleBadgeModal = () => ({
  type: TOGGLE_BADGE_MODAL,
});
export const toggleShareBadgeModal = () => ({
  type: TOGGLE_SHARE_BADGE_MODAL,
});
export const toggleSweepstakesBadgeModal = () => ({
  type: TOGGLE_SWEEPSTAKES_BADGE_MODAL,
});
export const showSweepstakesBadgeModal = (id) => ({
  type: SHOW_SWEEPSTAKES_BADGE_MODAL,
  payload: id,
});
export const hideLinkbar = () => ({
  type: HIDE_LINKBAR,
});

export const setKeyTerm = (keyTerm) => ({
  type: SET_KEYTERM,
  keyTerm,
});

export const clearKeyTerm = () => ({
  type: CLEAR_KEYTERM,
});

export const updateUserAction = (user) => ({
  type: UPDATE_USER,
  user,
});

export const updateProgress = (progress) => ({
  type: UPDATE_PROGRESS,
  progress,
});
export const clearProgress = () => ({
  type: CLEAR_PROGRESS,
});

export const updateFinishedTopics = (topics) => ({
  type: UPDATE_FINISHED_TOPICS,
  topics,
});

export const updateFinishedSections = (sections) => ({
  type: UPDATE_FINISHED_SUB_SECTION,
  sections,
});

export const updateCurrentTopic = (contentKey) => ({
  type: UPDATE_CURRENT_TOPIC,
  contentKey,
});

export const toggleShareModalAction = () => ({
  type: TOGGLE_SHARE_MODAL,
});

export const setSectionAction = (section) => ({
  type: SET_SECTION,
  section,
});

export const updateLanguages = (languages) => ({
  type: UPDATE_LANGUAGE,
  languages,
});

export const updateCurrentLanguage = (lang) => ({
  type: UPDATE_CURRENT_LANGUAGE,
  lang,
});

export const updateSharesCount = (shares) => ({
  type: UPDATE_SHARES_COUNT,
  shares,
});

export const updateSharesId = (id) => ({
  type: UPDATE_SHARES_ID,
  id,
});

export const updateAffiliate = (payload) => ({
  type: UPDATE_AFFILIATE,
  payload,
});

export const updateConfig = (payload) => ({
  type: UPDATE_CONFIG,
  payload,
});

export const updateAdobeSettings = (payload) => ({
  type: UPDATE_ADOBE_SETTINGS,
  payload,
});
